import type { RenameCandidate } from '@cli-types/core-engine/snapshots.js'
import { detectRenames } from './detect-renames.js'

export function detectStringRenameCandidates(
  removed: string[],
  added: string[]
): RenameCandidate[] {
  return detectRenames(removed, added, (entry) => entry)
}
